import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadStatusLoadingArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#999",
		d: "M9.57 14.88 4.9 10.197l1.07-1.07 2.85 2.85V5.574h1.5v6.404l2.834-2.835 1.07 1.085L9.57 14.88Z"
	})
});
export { SvgDownloadStatusLoadingArrow as ReactComponent };
